import React, {useState, useEffect} from 'react'
import {Modal } from 'react-bootstrap'
import {useHistory} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'


import DashBoardContainer from '../../components/containers/dashboardContainer'
import ReviewCard from '../../components/reviewCard'
import LoadingSpinner from '../../components/loadingSpiner'



import {
    fetchFirmApplication,
    updateFirmApplication,
    fetchFirmApplicationStatus,
    fetchFile
} from '../../actions' 

import {FETCH_FIRM_APPLICATION_STATUS_ID} from '../../store/loaders'

import ier_logo from '../../assets/images/icons/ier-logo2.png'



const FirmApplicationStatusModel = (props)=>{


    const history = useHistory()
    const dispatch = useDispatch()

    const apiResponse = useSelector((state=>{
        const {
            firmApplication, 
            fetchFile,
            firmApplicationSubmitted,
            updatedFirmApplication,
            loader
        } = state
        const {application} = firmApplication
        const {file} = fetchFile
        const {response} = firmApplicationSubmitted
        const {status} = updatedFirmApplication
        const {isLoading} = loader[FETCH_FIRM_APPLICATION_STATUS_ID] || {isLoading: false} 

        return{
            application,
            file,
            response,
            status,
            isLoading
        }
    }))


    const [applicationDetails, setApplicationDetails] = useState({})
    const [hasDownloaded, setHasDownloaded] = useState(false)
    const [download, setDownload] = useState(false)
    const [requestId,setRequestId] = useState('')

    const actionLoader = apiResponse.isLoading


    useEffect(()=>{
        if(props.data){
            dispatch(fetchFirmApplicationStatus(props.data.id))
        }   
    },[props.data])

    useEffect(()=>{
        if(apiResponse.status === requestId && apiResponse.response?.status === 'success'){
            history.push({
                pathname: '/applicant/payment-details',
                state: applicationDetails
            })
        }
    },[apiResponse.response])

    useEffect(()=>{
        if(apiResponse.file?.fileText != null && !hasDownloaded && download){
            var a = document.createElement("a");
            a.href =  "data:image/" +apiResponse.file?.type +";base64," + apiResponse.file?.fileText; 
            a.download = apiResponse.file?.name || 'File' + "." + apiResponse.file?.type || ''; 
            a.click();
            setHasDownloaded(true)
        }
    },[apiResponse.file])

    useEffect(()=>{
        if(apiResponse.application?.id){
            setApplicationDetails({
                ...apiResponse.application
            })
        }
    },[apiResponse.application])


    const handleSaveForLater = ()=>{
        const reqId = uuidv4()
        setRequestId(reqId)
        const sentData = {
            ...applicationDetails,
            step: 7,
            status: 'submitted'
        }
        if(props.data.id){
            dispatch(updateFirmApplication({
                data:{
                    ...sentData
                },
                id: props.data.id,
                reqId: reqId
            }))
        }
    }

    const handleSubmit = ()=>{
        // history.push('/applicant/payment-details')
        handleSaveForLater()
    }

    const handleFileDownload = (value)=>{
        let url 
        if(value){
            url = encodeURIComponent(value.substring(value.indexOf("/tmp"), value.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }


    const handleCancel = ()=>{
        props.hide()
     }

    return(
        <Modal
            show={props.show} 
            onHide={props.hide}
            centered
            size="xl">
            {!actionLoader ?
            (
            <div>
            <DashBoardContainer 
                handleSubmit={handleSubmit}
                handleClose={handleCancel}
                title="Next"
                borderLess={true}
                hasmiddleBtn={true}
                handleSaveForLater={handleSaveForLater}
                middleTitle="Save for Later"
                hasCloseBtn={true}
                hasButton={true}
                closeTitle="Close">
            <div className="application-status-sub-header mt-4">
                <div className="content">
                    <span className="title">Firm membership application</span>
                    <span className="title-content"></span>
                </div>
            </div>
            <div className="application-status-container mt-2 mb-4">
                <span className="general-span-text-none-auto-small" style={{fontSize: 14}}>Application Status</span>
                <span className="general-span-text-none-auto">{applicationDetails.status}</span>
            </div>
            <div className="dashboard-review-container"> 
                <div>
                    <ReviewCard
                        title="Company details"
                        path="/applicant/company/details"
                        hasEdit={applicationDetails?.status === 'not submitted' ?  false : true}>
                        <div className="review-details-content-conatiner" style={{justifyContent: 'space-between'}}>
                            
                            <div className="review-details-profile-container">
                                <div>
                                    <div>
                                        <span>Company names</span>
                                        <p>{applicationDetails.companyNames}</p>
                                    </div>
                                    <div>
                                        <span>Company activities</span>
                                        <p>{applicationDetails.companyActivities}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="review-details-gender-details">
                                <div>
                                    <span>Date of business registration</span>
                                    <p>{ applicationDetails.registrationDate && moment(applicationDetails.registrationDate).format('MMMM Do YYYY, h:mm:ss a')}</p>
                                </div>
                                <div>
                                    <span>Business Certificate number</span>
                                    <p>{applicationDetails.businessCertificateNumber}</p>
                                </div>
                            </div>                            
                        </div>
                    </ReviewCard>

                    <ReviewCard
                        title="Contact details"
                        path="/applicant/company/contacts"
                        hasEdit={applicationDetails?.status === 'not submitted' ?  false : true}
                        >
                            <div className="review-details-content-conatiner">
                                <div className="review-details-contact-container-first">
                                    <div className="d-flex">
                                        <div className="contancts-container">
                                            <div>
                                                <span>Phone number</span>
                                                <p>{applicationDetails.contactTelephoneNumber}</p>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div>
                                                <span>Email address</span>
                                                <p>{applicationDetails.contactEmail}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="seperator-contact"></div>
                                    <div className="d-flex">
                                        <div className="contancts-container">
                                            <div>
                                                <span>Secondary Phone number</span>
                                                <p>{applicationDetails.secondaryContactTelephoneNumber}</p>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div>
                                                <span>Main Email address</span>
                                                <p>{applicationDetails.secondaryContactEmail}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="review-details-contact-container-second">
                                    <div className="">
                                        <div>
                                            <span>Residence Address</span>
                                            <p>{applicationDetails.provinceId?.name}, {applicationDetails.districtId?.name}, {applicationDetails.sectorId?.name}, {applicationDetails.cellId?.name}, {applicationDetails.villageId?.name}, {applicationDetails.streetOrHouseNumber}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </ReviewCard>

                    <ReviewCard
                        title="Company Directors/ Shareholders"
                        path="/applicant/company/shareholders"
                        hasEdit={applicationDetails?.status === 'not submitted' ?  false : true}
                        >
                            <div className="review-details-content-conatiner">
                                <div className="review-details-contact-container-first" style={{width: '100%'}}>
                                    
                                        {applicationDetails.stakeholders?.length > 0 &&  applicationDetails.stakeholders?.map(value=>{
                                            return(
                                                <>
                                                    <div className="d-flex" style={{justifyContent: 'space-between'}}>
                                                        <div>
                                                            <div>
                                                                <span>Full names</span>
                                                                <p>{value.fullName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            <div>
                                                                <span>Qualification</span>
                                                                <p>{value.qualification}</p>
                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            <div>
                                                                <span>Phone</span>
                                                                <p>{value.telephoneNumber}</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <span>National ID number</span>
                                                            <p>{value.nationalIdNumber}</p>
                                                        </div>
                                                        <div>
                                                            <span>IER number</span>
                                                            <p>{value.ierMemberNumber}</p>
                                                        </div>
                                                    </div>
                                                    <div className="seperator-contact" style={{width:'100%'}}></div>
                                                </>
                                            )
                                        })}
                                </div>
                            </div>
                        </ReviewCard>
                    <ReviewCard
                        title="Projects accomplished details"
                        path="/applicant/company/projects"
                        hasEdit={applicationDetails?.status === 'not submitted' ?  false : true}
                        >
                            <div className="review-details-content-conatiner">
                                <div className="review-details-contact-container-first" style={{width: '100%'}}>
                                    {applicationDetails.projects?.length > 0 && applicationDetails.projects.map(value=>{
                                        return(
                                            <>
                                                <div className="d-flex" style={{justifyContent: 'space-between'}}>
                                                    <div>
                                                        <div>
                                                            <span>Name of the project</span>
                                                            <p>{value.name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        <div>
                                                            <span>Client</span>
                                                            <p>{value.client}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="seperator-contact" style={{width:'100%'}}></div>
                                            </>
                                        )   
                                    })
                                    }
                                </div>
                            </div>

                        </ReviewCard>

                        <ReviewCard
                            title="Attachments"
                            path="/applicant/company/attachments"
                            hasEdit={applicationDetails?.status === 'not submitted' ?  false : true}
                            >
                                    <div className="review-details-content-conatiner">
                                    <div className="review-details-contact-container-first" style={{width: '100%'}}>
                                        <div className="d-flex" style={{justifyContent: 'space-between'}}>
                                        
                                            { applicationDetails.technicalReportFile && <div>
                                                    <span>Technical report</span>
                                                    {/* <img src={`data:image/${applicationDetails.technicalReportFile?.type};base64,${applicationDetails.technicalReportFile?.fileText}`} style={{width: 150, height: 150}}/> */}
                                                    <p style={{marginBottom: '0px'}}>{applicationDetails.technicalReportFile?.name}</p>
                                                    <span 
                                                        onClick={()=>handleFileDownload(applicationDetails.technicalReportFile?.fileText)}
                                                        style={{cursor: 'pointer'}}>download</span>
                                                </div> }
                                        
                                        
                                            {applicationDetails.businessCertificateDocumentFile &&   <div>
                                                    <span> certified Business certificate</span>
                                                    {/* <img src={`data:image/${applicationDetails.businessCertificateDocumentFile?.type};base64,${applicationDetails.businessCertificateDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                                                    <p style={{marginBottom: '0px'}}>{applicationDetails.businessCertificateDocumentFile?.name}</p>
                                                    <span 
                                                        style={{cursor: 'pointer'}}
                                                        onClick={()=>handleFileDownload(applicationDetails.businessCertificateDocumentFile?.fileText)}
                                                    >download</span>
                                                </div> }



                                        { applicationDetails.rdbRegistrationDocumentFile &&  <div>
                                                    <span> RDB Registration Certificate</span>
                                                    {/* <img src={`data:image/${applicationDetails.rdbRegistrationDocumentFile?.type};base64,${applicationDetails.rdbRegistrationDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                                                    <p style={{marginBottom: '0px'}}>{applicationDetails.rdbRegistrationDocumentFile?.name}</p>
                                                    <span 
                                                        onClick={()=>handleFileDownload(applicationDetails.rdbRegistrationDocumentFile?.fileText)}
                                                        style={{cursor: 'pointer'}}>download</span>
                                                </div> }


                                        {  applicationDetails.taxClearanceDocumentFile &&   <div>
                                                    <span> RRA Tax Clearance Certificate</span>
                                                    {/* <img src={`data:image/${applicationDetails.taxClearanceDocumentFile?.type};base64,${applicationDetails.taxClearanceDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                                                    <p style={{marginBottom: '0px'}}>{applicationDetails.taxClearanceDocumentFile?.name}</p>
                                                    <span 
                                                    style={{cursor: 'pointer'}}
                                                    onClick={()=>handleFileDownload(applicationDetails.taxClearanceDocumentFile?.fileText)}>
                                                        download</span>
                                                </div> }

                                        </div>
                                        <div className="seperator-contact" style={{width:'100%'}}></div>
                                        <div className="d-flex" style={{justifyContent: 'space-between'}}>
                                        
                                            {applicationDetails.practicingLicenseDocumentFile &&  <div>
                                                    <span> Managing/Technical Director’s Practicing License</span>
                                                    {/* <img src={`data:image/${applicationDetails.practicingLicenseDocumentFile?.type};base64,${applicationDetails.practicingLicenseDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                                                    <p style={{marginBottom: '0px'}}>{applicationDetails.practicingLicenseDocumentFile?.name}</p>
                                                    <span 
                                                        style={{cursor: 'pointer'}}
                                                        onClick={()=>handleFileDownload(applicationDetails.practicingLicenseDocumentFile?.fileText)}>
                                                        download</span>
                                                </div>}
                                        
                                        
                                            {applicationDetails.companyProfileDocumentFile &&  <div>
                                                    <span> Company Profile</span>
                                                    {/* <img src={`data:image/${applicationDetails.companyProfileDocumentFile?.type};base64,${applicationDetails.companyProfileDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                                                    <p style={{marginBottom: '0px'}}>{applicationDetails.companyProfileDocumentFile?.name}</p>
                                                    <span 
                                                        style={{cursor: 'pointer'}}
                                                        onClick={()=>handleFileDownload(applicationDetails.companyProfileDocumentFile?.fileText)}
                                                    >download</span>
                                                </div>}
                                        
                                            { applicationDetails.rssbCertificateDocumentFile && <div>
                                                    <span> RSSB Certificate</span>
                                                    {/* <img src={`data:image/${applicationDetails.rssbCertificateDocumentFile?.type};base64,${applicationDetails.rssbCertificateDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                                                    <p style={{marginBottom: '0px'}}>{applicationDetails.rssbCertificateDocumentFile?.name}</p>
                                                    <span 
                                                        style={{cursor: 'pointer'}}
                                                        onClick={()=>handleFileDownload(applicationDetails.rssbCertificateDocumentFile?.fileText)}
                                                    >download</span>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </ReviewCard>
                        </div>
                    </div>
                </DashBoardContainer>
            </div>
            )
            :
            (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'}}>
                    <LoadingSpinner
                        color={'#1D834F'}/>
                </div>
            )
            }
        </Modal>
    )
}


export default FirmApplicationStatusModel